import {Injectable} from "@angular/core";
import {SessionActions} from "../../../shared/actions/session.actions";
import {MessageType} from "../../../shared/redux-store/session/session.types";
import {isApolloError} from "apollo-client/errors/ApolloError";

@Injectable()
export class ErrorHandlerService {


  constructor(private sessionActions: SessionActions) {

  }

  handleUserError(error: any, errorMsg ?: string, rethrow: boolean = false) {

    if (error) {
      console.error(error.message, [error]);
    }

    if (isApolloError(error)) {
      errorMsg = errorMsg ? errorMsg : "Es sind Fehler Aufgetreten: " + error.graphQLErrors.map(err => err.message).join(', ');
    }

    this.sessionActions.pushMessage(errorMsg ? errorMsg : 'Es ist ein Fehler aufgetreten, bitte versuchen Sie es erneut!', MessageType.ERROR);

    if (rethrow) {
      throw error;
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/error-handling/error-handler.service.ts